import * as React from 'react';


export default class UploadZip extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        return (
            <svg className={this.props.className} xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 50 62">
                <defs>
                    <path id="a" d="M48.941 11.596v45.816a2.824 2.824 0 0 1-2.823 2.823H2.824A2.824 2.824 0 0 1 0 57.412V2.824A2.824 2.824 0 0 1 2.824 0h34.522a3 3 0 0 1 2.12.879l8.596 8.595a3 3 0 0 1 .88 2.122z"/>
                    <path id="b" d="M2.057 2.824h4.389L8.14 10.17a3.991 3.991 0 0 1-3.89 4.889A3.991 3.991 0 0 1 .363 10.17l1.695-7.346z"/>
                </defs>
                <g fill="none" fillRule="evenodd">
                    <g transform="translate(.53 .882)">
                        <use fill="#FFF" xlinkHref="#a"/>
                        <path stroke="#E4E4E4" strokeWidth="2" d="M47.941 11.596a2 2 0 0 0-.586-1.415L38.76 1.586A2 2 0 0 0 37.346 1H2.824A1.824 1.824 0 0 0 1 2.824v54.588c0 1.007.816 1.823 1.824 1.823h43.294a1.824 1.824 0 0 0 1.823-1.823V11.596z"/>
                    </g>
                    <path fill="#323232" d="M16.63 50.764h5.735v1.883h-8.664v-1.375l5.625-8.102H13.71v-1.898h8.531v1.344l-5.61 8.148zm9.704 1.883H23.99V41.272h2.344v11.375zm4.515-4.008v4.008h-2.343V41.272h4.437c.854 0 1.606.156 2.254.469.649.312 1.147.756 1.496 1.332.35.575.524 1.23.524 1.965 0 1.114-.382 1.993-1.145 2.636-.763.644-1.819.965-3.168.965H30.85zm0-1.898h2.094c.62 0 1.093-.146 1.418-.438.326-.291.488-.708.488-1.25 0-.557-.164-1.008-.492-1.351-.328-.344-.78-.521-1.36-.532H30.85v3.57z"/>
                    <path fill="#D6D6D6" d="M22.176 26.294h4.706v1.882h-4.706zM22.176 22.53h4.706v1.881h-4.706z"/>
                    <g transform="translate(20.294 6.53)">
                        <use fill="#D6D6D6" xlinkHref="#b"/>
                        <path stroke="#323232" strokeWidth="2" d="M2.853 3.824l-1.516 6.571a2.991 2.991 0 1 0 5.83 0L5.65 3.824H2.853z"/>
                        <circle cx="4.235" cy="2.353" r="2.353" fill="#D6D6D6" stroke="#323232" strokeWidth="2"/>
                    </g>
                    <path fill="#D6D6D6" d="M22.176 30.058h4.706v1.882h-4.706zM22.176 33.823h4.706v1.882h-4.706z"/>
                </g>
            </svg>
        )
    }
}
